<template>
  <el-dialog
    :title="getTitle"
    :visible="isShowGoods"
    :before-close="closeGoods"
    :modal="false"
    class="goods-dialog"
    style="width: 70%;margin: 0 auto;font-size:20px;"
    @open="open"
  >
    <div>
      <div style="display: flex;">
        <el-select
          v-model="typename"
          :placeholder="$t('SupplierClass.placeholder')"
          style="width: 200px;"
        >
          <el-option
            style="height: auto;background-color:white;"
            v-model="typeid"
          >
            <good-class-tree
              :changestyle="false"
              @plusTreeClass="chooseTreeClass"
              :currentPurchaseClass="Stypename"
            ></good-class-tree>
          </el-option>
        </el-select>
        <el-input
          v-model="search"
          :placeholder="$t('GoodsList.placeholder')"
          style="width:200px;"
          @blur="searchChange"
        ></el-input>
        <el-button @click="getGoodsList(1)" type="primary">{{
          $t("GoodsList.search")
        }}</el-button>
      </div>
      <!-- <div>
				<el-checkbox-group v-model="goodsObj" style="width: 100%;margin: 10px auto;font-size: 16px;">
					<el-checkbox style="width: 33.3%;margin-top: 5px;margin-bottom: 5px;" class="getGoodCheckbox"  v-for="(item,index) in goodsList" :key="item.index" :label="item">{{item.name}}</el-checkbox>
				</el-checkbox-group>
			</div> :cell-style="cellStyle" :row-class-name="tableRowClassName"-->
      <div>
        <el-table
          ref="itemmultipleTable"
          class="itemmultipleTable"
          :data="goodsList"
          tooltip-effect="dark"
          :cell-style="cellStyle"
          :loading="isTblLoading"
          style="width: 100%;margin: 8px 0;height: 650px;overflow: hidden;overflow-y: scroll;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>

          <el-table-column
            align="center"
            :formatter="tableFormat"
            v-for="(item, index) in goodsTableHeader"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :class="item.IsProject === '1' ? 'active' : ''"
          ></el-table-column>
        </el-table>
      </div>

      <el-footer>
        <el-pagination
          style="text-align: end;"
          v-if="goodsList != ''"
          @size-change="getGoodsList"
          @current-change="getGoodsList"
          :current-page.sync="currentPage"
          :page-size="recordCount"
          layout="total, prev, pager, next"
          :total="tableTotal"
        ></el-pagination>
      </el-footer>

      <div style="text-align: end">
        <el-button
          @click="GoodsConfirm"
          type="primary"
          style="text-align: end"
          >{{ $t("header.confirmButtonText") }}</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import wmsApi from "@/request/wmsApi";
import GoodClassTree from "./GoodClassTree";
import baseFunction from "@/utils/baseFunction";
export default {
  name: "GetGoodsList",
  components: {
    GoodClassTree
  },
  props: {
    isShowGoods: {
      required: true,
      default: false,
      type: Boolean
    },
    // Stypeid:{
    // 	required:true,
    // 	default:0,
    // 	type:Number
    // },
    Stypename: {
      required: false,
      default: "",
      type: String
    },
    purchaseType: {
      type: String,
      default: "Local",
      required: false
    },
    getTitle: {
      type: String,
      default: "",
      required: false
    },
    projectId: {
      required: false,
      default: 0,
      type: Number
    },
    arrData: {
      required: false,
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      currentPage: 1,
      recordCount: 30,
      tableTotal: 0,
      goodsList: [],
      search: "",
      goodsObj: [],

      typename: "",
      typeid: "",
      isTblLoading: false
    };
  },
  mounted() {
    console.log(this.Stypename);
  },
  methods: {
    open() {
      this.goodsObj = [];
      this.search = "";
      this.currentPage = 1;
      this.getGoodsList();
    },

    searchChange(newValue) {
      console.log(newValue);
      this.getGoodsList(1);
    },

    tableRowClassName({ row, rowIndex }) {
      console.log(row);
      if (row.IsProject == 1) {
        return "IsProject";
      } else if (row.IsPurchase == 1) {
        return "IsPurchase";
      } else if (row.IsProject == 1 && row.IsPurchase == 1) {
        return "All";
      }

      return "";
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (row.IsProject == 1 && row.IsPurchase == 1) {
        return {
          background: "#7FFFD4",
          color: "#ff0000"
        };
      } else if (row.IsProject == 1 && row.IsPurchase == 0) {
        return {
          background: "#7FFFD4",
          color: "#000"
        };
      } else if (row.IsPurchase == 1) {
        return {
          color: "#ff0000"
        };
      }
    },

    chooseTreeClass(data) {
      // console.log(data);
      this.typename = data.name;
      this.typeid = data.id;
      this.currentPage = 1;

      this.getGoodsList();
    },

    handleSelectionChange(val) {
      this.goodsObj = val;
    },

    async getGoodsList(page) {
      try {
        console.log(page);
        if (page) this.currentPage = page;

        this.isTblLoading = true;

        this.goodsList = [];
        let sucRes = await wmsApi.GetGoodsList(
          this.token,
          this.search,
          this.typeid,
          "1",
          this.purchaseType,
          this.currentPage,
          this.recordCount,
          this.projectId
        );

        this.isTblLoading = false;
        sucRes.data.forEach((itemObj, index) => {
          if (itemObj.adddt != null && itemObj.adddt != "") {
            itemObj.adddt = baseFunction.formatterDate(itemObj.adddt);
          }

          itemObj.priceList.forEach(priceObj => {
            if (priceObj.isUsed === 1) {
              itemObj.shortEng = priceObj.currency;
              return;
            }
          });
        });

        this.goodsList = sucRes.data;
        this.tableTotal = sucRes.totalCount;

        this.setItemSelected();
      } catch (ex) {
        console.warn(ex);
      }
    },

    setItemSelected() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.itemmultipleTable.clearSelection();
          if (this.arrData.length > 0) {
            this.arrData.forEach(dataObj => {
              this.$refs.itemmultipleTable.toggleRowSelection(
                this.goodsList.find(finditem => {
                  return finditem.id == dataObj.Goods.id;
                }),
                true
              );
            });
          } else {
            this.$refs.itemmultipleTable.clearSelection();
          }
        });
      }, 1000);
    },

    GoodsConfirm() {
      this.goodsObj = this.$refs.itemmultipleTable.selection;
      let index = this.goodsObj.length;
      while (index >= 0) {
        if (this.goodsObj[index] === undefined) {
          this.goodsObj.splice(index, 1);
        }
        --index;
      }

      this.$emit("selectGoods", this.goodsObj);
    },

    closeGoods(done) {
      this.$confirm(this.$t("header.confirm"), this.$t("header.tishi"), {
        confirmButtonText: this.$t("header.confirmButtonText"),
        cancelButtonText: this.$t("header.cancelButtonText"),
        type: "warning"
      })
        .then(() => {
          this.search = "";
          // this.getGoodsList();
          this.goodsObj = [];
          // this.$emit('selectGoods',this.goodsObj)
          this.$emit("closeShowGoods", false);
          done();
        })
        .catch(() => {});
    },

    tableFormat(row, column, cellValue, index) {
      if (column.label == this.$t("GoodsList.dialog[4]")) {
        if (row.price) {
          row.price += "";
          if (!row.price.includes(".")) row.price += ".";
          return row.price
            .replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
              return $1 + ",";
            })
            .replace(/\.$/, "");
        }
      }

      return cellValue;
    }
  },
  computed: mapState({
    token: state => state.user.token,

    // currentPurchaseClass() {
    // 	let purchaseModel = this.purchaseClass.find(match => match.id === this.goodform.classid);
    // 	return purchaseModel ? purchaseModel.purgoods_En : '';
    // },

    goodsTableHeader() {
      return [
        {
          prop: "num",
          label: this.$t("GoodsList.dialog[0]")
        },
        {
          prop: "name",
          label: this.$t("GoodsList.dialog[2]")
        },
        {
          prop: "localDes",
          label: this.$t("GoodsList.dialog[18]")
        },
        {
          prop: "price",
          label: this.$t("GoodsList.dialog[4]")
        },
        {
          prop: "shortEng",
          label: this.$t("GoodsList.dialog[26]")
        },
        {
          prop: "stock",
          label: this.$t("GoodsList.dialog[13]")
        },
        {
          prop: "unit",
          label: this.$t("GoodsList.dialog[5]")
        }
      ];
    }
  }),
  watch: {
    // typeid(newVal, oldVal) {
    // 	if (newVal != oldVal) {
    // 		this.currentPage = 1;
    // 		setTimeout(() => {
    // 			this.getGoodsList();
    // 		}, 1000);
    // 	}
    // },
    // search(newVal, oldVal) {
    // 	if (newVal != oldVal) {
    // 		this.currentPage = 1;
    // 		this.getGoodsList();
    // 	}
    // }
  }
};
</script>

<style>
.goods-dialog .el-dialog .el-dialog__header {
  background: #2c3e50;
}

.goods-dialog .el-dialog .el-dialog__header .el-dialog__title {
  color: white;
}

.goods-dialog .el-dialog .el-dialog__header .el-dialog__headerbtn {
  color: white;
  font-weight: bold;
  font-size: 20px;
}

.getGoodCheckbox .el-checkbox__label {
  font-size: 18px;
}

.goods-dialog .el-dialog {
  margin-top: 5vh !important;
}

.goods-dialog::-webkit-scrollbar {
  width: 0 !important;
}

/deep/.active {
  background-color: #7fffd4;
}

.itemmultipleTable .IsProject {
  background: #7fffd4;
  color: #000;
}

.itemmultipleTable .IsPurchase {
  /* color: #ff0000; */
}

.itemmultipleTable .All {
  background: #7fffd4;
  /* color: #ff0000; */
}
</style>



// WEBPACK FOOTER //
// src/components/common/PurchasingManagement/GetGoodsList.vue